import axios from 'axios';
import { NETWORK, FLOW_TYPE, REDIRECT_SUFFIX } from '../../App/AppConstants';
import { CONTEXT_TYPE } from '../../App/SkeletonPage/SkeletonPageConstants';
import _ from 'lodash';
import postMiniBrowserMessage from '../../../core/postMiniBrowserMessage';
import setUrl from '../../App/SetUrl';
import { handleRedirect } from '../../../US/pages/TermsPage/TermsPageActions';
import { safeStringify, safeStringifyAxios } from '../../../shared-utilities/safeStringify';

const PAYPAL_HOME_URI = 'https://www.paypal.com';

const handleReturnFlowRedirect = (response, isCancel, state) => {
    capeLog && capeLog('handleReturnFlowRedirect: response length: ' + safeStringifyAxios(response).length + ' isCancel? ' + isCancel);

    const serverData = _.get(state, 'serverData');

    if (handleRedirect(response, serverData)) {
        return;
    }

    let returnUrl = _.get(response, 'data.returnUrl');
    const flowType = _.get(state, 'serverData.flow', FLOW_TYPE.DIRECT_APP);
    const contextType = _.get(state, 'serverData.contextType', CONTEXT_TYPE.FULL_PAGE);
    const isSignin = returnUrl && returnUrl.indexOf('signin') > -1;
    const cartId = _.get(state, 'serverData.contextId', '');

    // In IE browsers (IE8 and higher) , when the security -> Enable protected mode setting is not in sync between internet, local intranet, trusted sites or restricted sites,
    // the opener object is undefined. This causes javascript error "unable to get property window from undefined property" when trying to do opener.window.parent !== null
    // opener !== null returns true when opener is undefined. Opener object is null in Full Page mode in non IE browsers.
    if (isSignin) {
        setUrl(window, returnUrl);
        return;
    }

    switch (flowType) {
        case FLOW_TYPE.DIRECT_APP:
            if (opener && opener.window && opener.window.parent) {
                capeLog && capeLog('handleReturnFlowRedirect: DA opener with ancestor: ', opener.location && opener.location.ancestorOrigins);
                if (!returnUrl || isMarketingGuidInRedirectFlowSelfCloseGuidList(state)) {
                    capeLog && capeLog('handleReturnFlowRedirect: DA opener, no return url closing the currrent window');
                    self.close();
                } else {
                    capeLog && capeLog('handleReturnFlowRedirect: DA opener, set opener url to ' + returnUrl + ', closing the current window and reloading the opener');
                    setUrl(opener.window, returnUrl, serverData);
                    self.close();
                    opener.window.location.reload();
                }
            } else if (!returnUrl) {
                capeLog && capeLog('handleReturnFlowRedirect: DA no return url redirecting to PayPal homepage');
                setUrl(window, PAYPAL_HOME_URI);
            } else {
                capeLog && capeLog('handleReturnFlowRedirect: DA redirect to return url ' + returnUrl);
                setUrl(window, returnUrl, serverData);
            }
            return;
        case FLOW_TYPE.HERMES:
            if (isCancel) {
                // Handle checkout.js/sdk
                if (window.xprops && window.xprops.onCancel) {
                    window.xprops.onCancel({ cartId, cancelUrl: returnUrl });
                } else if (window.name === 'PPFrame') {
                    postMiniBrowserMessage(safeStringify({ returnUrl }));
                } else {
                    setUrl(window, returnUrl, serverData); 
                }
            }
            break;
        case FLOW_TYPE.PROX:
            if (isCancel) {
                if (contextType === CONTEXT_TYPE.MB_CONTEXT) {
                    window.close();
                    return;
                }
            }
            break;
    }

    if (!returnUrl) {
        capeLog && capeLog('handleReturnFlowRedirect: no returnUrl, setting default');
        returnUrl = PAYPAL_HOME_URI;
    }

    capeLog && capeLog('handleReturnFlowRedirect: redirecting to: ' + returnUrl);
    setUrl(window, returnUrl, serverData);
};

/**
 * This is a workaround so we can call "self.close()" for certain PROX DA campaigns.
 * This function will check our redux store for our remote config "redirectFlowSelfCloseGuidList",
 * and check if the user came to CAPE via one of those campaign guids.
 * @param {*} state The entire state of the redux store
 */
export const isMarketingGuidInRedirectFlowSelfCloseGuidList = (state) => {
    const guidList = _.get(state, 'serverData.featureFlags.redirectFlowSelfCloseGuidList');
    const marketingGuid = _.get(state, 'serverData.marketingGuid');
    return typeof guidList === 'string' && _.includes(guidList.split('|'), marketingGuid);
};

/**
 * Handle all redirect scenarios from CAPE.
 * @param {string} actionUri
 * @param {boolean} isCancel
 */
export const redirectFlowAction = (actionUri) => async(dispatch, getState) => {
    const { serverData = {} } = getState();
    const isCancelRedirect = (actionUri === REDIRECT_SUFFIX.CANCEL_REDIRECT);

    capeLog && capeLog('redirectFlowAction:RedirectUrl ' + actionUri);

    try {
        const response = await axios
            .request({
                method: 'get',
                url: actionUri,
                headers: NETWORK.REQUEST.XHR.HEADER
            })
            .catch(err => err.response ? err.response : new Error(err));
        await handleReturnFlowRedirect(response, isCancelRedirect, getState());
    } catch (error) {
        capeLog && capeLog('redirectFlowAction:error: ' + (error && error.message));
        setUrl(window, actionUri, serverData); // in case  AJAX call fails.
    }
};
